import { createFileRoute, Outlet } from "@tanstack/react-router";
import SidebarLayout from "../../../layouts/SidebarLayout";

export const Route = createFileRoute(
  "/(hidden-folder)/_layouts/_sideDrawerLayout"
)({
  component: () => (
    <SidebarLayout>
      <Outlet />
    </SidebarLayout>
  ),
});
